// Popup functionality
$(document).ready(function(){

  popupCookie = getCookie('fastenerPopup');
  
  if (popupCookie === 'true') {
    $('#fastener-popup').hide();
    return false;
  } else {
  
    // After a set amount of time, the popup appears
    setTimeout(function(){
      $('#fastener-popup').addClass('visible');
    }, 3000);
  }
  
  // Clicking the close button hides the popup and assigns a cookie to the user to keep the popup from showing again for 1 day
  $('.popup .close, .popup .button-primary').on('click', function(){
    setCookie('fastenerPopup', 'true', 1);
    var $popup = $(this).parent('.popup');
    $popup.addClass('dismissed');
    setTimeout(function(){
      $popup.hide();
    }, 500);
  });
});

$(document).mouseup(function(e) {
    var $popup = $("#fastener-popup");

    // if the target of the click isn't the container nor a descendant of the container
    if (!$popup.is(e.target) && $popup.has(e.target).length === 0) 
    {
        setCookie('fastenerPopup', 'true', 1);
        $popup.addClass('dismissed');
        setTimeout(function(){
          $popup.hide();
        }, 500);
    }
});

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}